<template>
  <div v-loading="showFlag">
    <t-card>
      <div>
        <!-- 見積No.テーブル -->
        <t-table
          ref="removableQuoteNoTable"
          :data="removableQuoteNoTable"
          header-cell-class-name="bg-default"
          :height="detailHeight"
          border
        >
          <t-table-column
            type="selection"
            min-width="55"
            align="center"
            header-align="center" />

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :align="column.align"
          >
          </t-table-column
        ></t-table>
        <t-row type="flex" justify="end">
          <t-button
            round
            type="danger"
            style="margin-top: 10px"
            class="button_common"
            ref="delBtn"
            :disabled="removableQuoteNoTable.length == 0"
            @click="deleteClick()"
          >
            <i class="el-icon-delete"></i>
            {{ $t("resource.sys.delete") }}
          </t-button>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  deleteDataImportInfoByQuoteNo,
  searchRemovableQuoteNoByDIdNo,
} from "@/services/dataImport";
import {
  getDialogContentHeight,
  getDialogContentHeightComm,
} from "@/utils/comFunction";
import { Message, Modal } from "@tellus/component";

import { DIALOG_LINE_HEIGHT, STR_EMPTY } from "@/utils/const";
export default {
  data() {
    return {
      //見積No.テーブル
      removableQuoteNoTable: [],

      //見積No.テーブルの列
      columns: [
        {
          prop: "didQuoteNo",
          label: t("resource.DATA_IMPORT.QUOTE_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          class: "cell_txt_left",
        },
      ],

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
	  // 画面と文字サイズの調整	
      //明細情報のheight
      // detailHeight: getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 0,
      //   DIALOG_LINE_HEIGHT * 1,
      //   0
      // ),
      detailHeight: getDialogContentHeightComm(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      ),
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      data: null,

      nbUpdateTimeLocal: this.nbUpdateTime,

      showFlag: false,
    };
  },
  props: {
    dataImportNo: {
      Type: String,
      default: STR_EMPTY,
    },
  },
  mounted() {
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      //削除された「見積No.」を検索する
      searchRemovableQuoteNoByDIdNo({
        didNo: this.dataImportNo,
      })
        .then((res) => {
          //見積No.テーブル
          this.removableQuoteNoTable = res.dataImportDetailInfos;
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
	  // 画面と文字サイズの調整
      // this.detailHeight = getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 0,
      //   DIALOG_LINE_HEIGHT * 1,
      //   0
      // );
      this.detailHeight = getDialogContentHeightComm(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      );
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    },

    //削除ボタン
    deleteClick() {
      var data = this.$refs.removableQuoteNoTable.selection.slice();

      if (data.length >= 1) {
        var msg;
        var deleteAllFlag = false;
        if (data.length == this.removableQuoteNoTable.length) {
          msg = t("message.DATA_IMPORT.DELETE_ALL_CONFIRM");
          deleteAllFlag = true;
        } else {
          msg = t("resource.sys.deleteMessage");
        }

        let delList = [];
        for (let index = 0; index < data.length; index++) {
          delList.push(data[index].didQuoteNo);
        }

        Modal.showWarning("", msg, {
          $type: "prompt",
          confirmButtonText: t("resource.button.sure"),
          cancelButtonText: t("resource.button.cancel"),
          showCancelButton: true,
        }).then(() => {
          //削除受注データ取込情報
          deleteDataImportInfoByQuoteNo({
            delList: delList,
            deleteAllFlag: deleteAllFlag,
            deleteFlagByDid: true,
            didNo: this.dataImportNo,
            user: getUserInfo().UserId,
          })
            .then(() => {
              Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));

              this.$emit("ok", deleteAllFlag);
            })
            .catch((err) => {
              this.showFlag = false;
              if (err.data != null) {
                Message.showError(
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                );
              } else {
                Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
              }
              //検索処理を行う
              this.init();
            });
        });
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-table .current-row > td {
  background-color: #b2d8ff;
}
</style>
